import React, { useCallback, useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import RouteContext from 'src/routes/context';
import {
  IconButton as IconButtonComponent,
  ButtonSize,
} from '@prisjakt/ui/button/variants';
import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import { IconTrash } from '@prisjakt/ui/icon';

export const ClearFilterButton = styled(IconButtonComponent)`
  padding: ${layout.measurements.spacing025};
`;

type Props = {
  property?: string;
};

const ClearFilter = ({ property }: Props) => {
  const { t } = useContext(AppContext);
  const { dispatch, getState } = useContext(RouteContext);
  const filterValue = getState()?.filters?.find(
    (filter: any) => filter.property === property
  );
  const clearFilter = useCallback(
    () => dispatch({ type: 'FILTER_REMOVE', property }),
    [dispatch, property]
  );

  if (!filterValue) {
    return null;
  }

  return (
    <ClearFilterButton
      size={ButtonSize.SMALL}
      onClick={clearFilter}
      disabled={!filterValue}
      containerProps={{
        title: t('filter', 'button.clear-filter'),
      }}
    >
      <IconTrash color="maybeBlue700" />
    </ClearFilterButton>
  );
};

export default ClearFilter;
